import { useRef } from "react";
import useClickOutside from "../../../hooks/useClickOutside";

export const SelectOption = ({ valuesList, value, onClick, onClickOutside }) => {

    const selectRef = useRef(null);
    useClickOutside(selectRef, () => onClickOutside)

    return (
        <div ref={selectRef}>
            {valuesList.map((opt, i) =>
                <div
                    className={`option ${value === opt.value ? "active" : ""}`}
                    key={i}
                    onClick={() => onClick(opt.value)}
                >
                    {opt.text}
                </div>
            )}
        </div>
    )
}